/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('select2');
require('pc-bootstrap4-datetimepicker');
require('daterangepicker/daterangepicker');
require('chart.js');

window.Vue = require('vue');
window.toastr = require('toastr');
window.moment = require('moment');
window.Swal = require('sweetalert2');
import store from './components/DocumentLibrary/Store/store';

//Partials
require('./partials/globals');
require('./partials/permissions');
require('./partials/error_handler');
require('./partials/client_contacts');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

Vue.component('modal', require('./components/Generic/Modal.vue').default);
Vue.component('document-library', require('./components/DocumentLibrary/Base.vue').default);
Vue.component('job-profitability', require('./components/JobProfitability.vue').default);
Vue.component('async-form', require('./components/Generic/AsyncForm.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    store,
    el: '#app'
});

$(document).ready(function() {
    // $('#contact').select2({
    //     tags: true,
    //     insertTag: function (data, tag) {
    //         if ($('#client').val() == '') {
    //             toastr.error('Client must be populated before creating a contact');
    //             return null;
    //         }
    //
    //         data.push(tag);
    //     }
    // });
    //
    // $('#contact').on('select2:select', function (e) {
    //
    //     let item = contacts[e.params.data.id];
    //
    //     if (!item) {
    //         item = {
    //             name: e.params.data.text,
    //             email: ''
    //         };
    //     }
    //
    //     $('#contacts-table-body').append(`
    //     <tr id="contact-${item.id}">
    //         <td>${item.name}</td>
    //         <td>${item.email}</td>
    //     </tr>
    // `)
    // });
    //
    // $('#contact').on('select2:unselect', function (e) {
    //     $('#contacts-table-body').find(`#contact-${e.params.data.id}`).remove();
    // });
    //
    // $('#client').change(function () {
    //     setSelect($(this), $('#contact'));
    //     setSelect($(this), $('#primary_contact'));
    //
    //     elem.empty();
    // });
    //
    // function setSelect(elem, appendTo){
    //     appendTo.empty();
    //
    //     if (elem.val() != '') {
    //         appendTo.prop('disabled', '');
    //     } else {
    //         appendTo.append('<option value="" selected="selected">Please Select a Client</option>').trigger('change');
    //         appendTo.prop('disabled', 'disabled');
    //     }
    //
    //     $.each(elem.find('option:selected').data('contacts'), function (key, value) {
    //         appendTo.append('<option value=' + value.id + '>' + value.name + '</option>');
    //     });
    // }
    //
    // $.each($('#client').find('option:selected').data('contacts'), function (key, value) {
    //     $('#contact').append('<option value=' + value.id + '>' + value.name + '</option>');
    //     $('#primary_contact').append('<option value=' + value.id + '>' + value.name + '</option>');
    // });
    //
    // if ($('#contact').data('prepopulate') != '') {
    //
    //     var elem = $('#contact');
    //
    //     if (typeof (elem.data('prepopulate')) == 'object') {
    //         $.each(elem.data('prepopulate'), function (key, value) {
    //             elem.find('option[value="' + value + '"]').prop('selected', 'selected');
    //         });
    //     }
    //
    //     elem.prop('disabled', '');
    // }
    //
    // if ($('#primary_contact').data('prepopulate') != '') {
    //
    //     var elem = $('#primary_contact');
    //
    //     if (typeof (elem.data('prepopulate')) == 'object') {
    //         $.each(elem.data('prepopulate'), function (key, value) {
    //             elem.find('option[value="' + value + '"]').prop('selected', 'selected');
    //         });
    //     }
    //
    //     elem.prop('disabled', '');
    // }
    //
    // if ($('#client').val() == '') {
    //     var elem = $('#contact');
    //     elem.prop('disabled', 'disabled');
    //     elem.append('<option value="" selected="selected">Please Select a Client</option>').trigger('change');
    //
    //     elem = $('#primary_contact');
    //     elem.prop('disabled', 'disabled');
    //     elem.append('<option value="" selected="selected">Please Select a Client</option>').trigger('change');
    // }
    //
    //
    // var s_contacts = $('#contact option:selected');
    //
    // s_contacts.each(function() {
    //
    //     let item = contacts[$(this).val()];
    //
    //     if (!item) {
    //         item = {
    //             name: $(this).val(),
    //             email: ''
    //         };
    //     }
    //
    //     $('#contacts-table-body').append(`
    //         <tr id="contact-${item.id}">
    //             <td>${item.name}</td>
    //             <td>${item.email}</td>
    //         </tr>
    //     `)
    // });
});
//Pages
require('./pages/tender');
require('./pages/jobs');
require('./pages/labour_costs');
require('./pages/clients');
require('./pages/weekly_costings');
require('./pages/sales_invoices');
